import React, {useEffect, useState} from 'react';
import axios from "axios";
// @ts-ignore
import {Plus} from '@phosphor-icons/react';
import HorizontalSubMenuComponent from "./HorizontalSubMenuComponent";
import {getBaseUrlNodeServer} from "../../config";

const Contacts = () => {
	const verifiedemail = sessionStorage.getItem("verifiedemail");
	const [isLoading, setIsLoading] = useState(true);
	const [userContacts, setUserContacts] = useState([]);
	const [activeTab, setActiveTab] = useState(0); // 0 = Contacts, 1 = Upload CSV
	const [addRowSignal, setAddRowSignal] = useState(0);

	const refetchContacts = async () => {
		try {
			axios.defaults.baseURL = getBaseUrlNodeServer();
			const response = await axios.post('getusercontacts', {verifiedemail});
			setUserContacts(Array.isArray(response.data) ? response.data : []);
		} catch (error) {
			console.error('Error fetching contacts:', error.message);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		refetchContacts();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleAddContact = () => {
		setActiveTab(0);
		setAddRowSignal(s => s + 1);
	};

	return (
		<div className="bg-slate-50/40 min-h-screen">
			<div className="max-w-6xl mx-auto px-6 py-8">
				<div className="flex items-center justify-between gap-4 mb-6">
					<h1 className="text-2xl font-semibold text-slate-900 tracking-tight">Contacts</h1>
					<button
						type="button"
						onClick={handleAddContact}
						className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full px-4 py-2 text-sm font-semibold shadow-sm">
						<Plus size={14} weight="bold"/>
						Add contact
					</button>
				</div>

				<HorizontalSubMenuComponent
					userContacts={userContacts}
					isLoading={isLoading}
					activeTab={activeTab}
					setActiveTab={setActiveTab}
					addRowSignal={addRowSignal}
					onAddContact={handleAddContact}
					onSwitchToUpload={() => setActiveTab(1)}
					refetchContacts={refetchContacts}
				/>
			</div>
		</div>
	);
};

export default Contacts;
